import React from 'react';
import ListPdf from './listPdf';

// La liste porte sa propre fiche : cet enrobage n'ajoutait qu'une grille.
function Pdf() {
  return <ListPdf />;
}

export default Pdf;
